import React from "react";
import { Link } from "react-router-dom";
import logo from "../imgs/logo.svg";
import logout from "../imgs/logout.svg";
import dashboardicon from "../imgs/dashboard.svg";
import darkdashboard from "../imgs/darkdashboard.svg";
import phone from "../imgs/phone.svg";
import wifi from "../imgs/wifi.svg";
import tv from "../imgs/tv.svg";
import lighting from "../imgs/lighting.svg";
import airtime from "../imgs/airtime.svg";
import whitelogout from "../imgs/logoutwhite.svg";
import transaction from "../imgs/transaction.svg";
import whitetransaction from "../imgs/whitetransaction.svg";
import headset from "../imgs/headset.svg";
import mtn from "../imgs/mtn.svg";
import airtel from "../imgs/airtel.svg";
import mobile from "../imgs/9mobile.svg";
import right from "../imgs/right.svg";
import whiteheadset from "../imgs/whiteheadset.svg";
import down from "../imgs/down.svg";
import Status from "./status";

function sidebar({ page }) {
  return (
    <div className="bg-[#EFF3FB] w-[304px] flex flex-col overflow-y-auto  justify-between gap-8  h-full fixed  p-8 ">
      <div className="w-full h-full ">
        <img src={logo} alt="" />
        <div className="flex flex-col  mt-8  ">
          <div className="flex flex-col gap-3 text-[#4C689E] w-[230px] ">
            <Link to="/">
              {page === "dashboard" ? (
                <div className="flex items-center px-[10px]  py-[9px] justify-center bg-[#4169E1] rounded-xl">
                  <div className="flex w-[197px] justify-between">
                    <div className="flex gap-[14px]">
                      <img src={dashboardicon} alt="" />
                      <p className="font-medium text-[#ffffff] text-[16px] leading-7 tracking-[2%]">
                        Dashboard
                      </p>
                    </div>
                    {/* <img src={down} alt="" /> */}
                  </div>
                </div>
              ) : (
                <div className="flex items-center px-[10px]  py-[9px] justify-center hover:bg-slate-300  rounded-xl">
                  <div className="flex w-[197px] justify-between">
                    <div className="flex gap-[14px]">
                      <img src={darkdashboard} alt="" />
                      <p className="font-medium  text-[16px] leading-7 tracking-[2%]">
                        Dashboard
                      </p>
                    </div>
                    {/* <img src={down} alt="" /> */}
                  </div>
                </div>
              )}
            </Link>

            <Link to="/transaction">
              {page === "transaction" ? (
                <div className="flex items-center px-[10px]  py-[9px] justify-center bg-[#4169E1] rounded-xl">
                  <div className="flex w-[197px] justify-between">
                    <div className="flex gap-[14px]">
                      <img src={whitetransaction} alt="" />
                      <p className="font-medium text-[#ffffff] text-[16px] leading-7 tracking-[2%]">
                        Transaction History
                      </p>
                    </div>
                    {/* <img src={down} alt="" /> */}
                  </div>
                </div>
              ) : (
                <div className="flex items-center px-[10px]  py-[9px] justify-center hover:bg-slate-300  rounded-xl">
                  <div className="flex w-[197px] justify-between">
                    <div className="flex gap-[14px]">
                      <img src={transaction} alt="" />
                      <p className="font-medium  text-[16px] leading-7 tracking-[2%]">
                        Transaction History
                      </p>
                    </div>
                    {/* <img src={down} alt="" /> */}
                  </div>
                </div>
              )}
            </Link>

            <Link to="/atc">
              {page === "airtimetocash" ? (
                <div className="flex flex-col gap-4">
                  <div className="flex items-center px-[10px]  py-[9px] justify-center bg-[#4169E1] rounded-xl">
                    <div className="flex w-[197px] justify-between">
                      <div className="flex gap-[14px]">
                        <img src={whitelogout} alt="" />
                        <p className="font-medium text-[#ffffff] text-[16px] leading-7 tracking-[2%]">
                          Airtime to Cash
                        </p>
                      </div>
                      {/* <img src={right} alt="" /> */}
                    </div>
                  </div>
                  <div className="flex gap-2 items-center">
                    <img
                      src={mtn}
                      className="hover:scale-105 hover:duration-150 active:opacity-65"
                    />
                    <img
                      src={airtel}
                      className="hover:scale-105 hover:duration-150 active:opacity-65"
                    />
                    <img
                      src={mobile}
                      className="hover:scale-105 hover:duration-150 active:opacity-65"
                    />
                    <div className="text-[#4169E1] flex items-center font-semibold text-[14px] leading-7 hover:scale-105 hover:duration-150 tracking-[2%]">
                      <p>More</p> <img src={right} />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="flex items-center px-[10px]  py-[9px] justify-center hover:bg-slate-300 rounded-xl">
                  <div className="flex w-[197px] justify-between">
                    <div className="flex gap-[14px]">
                      <img src={airtime} alt="" />
                      <p className="font-medium  text-[16px] leading-7 tracking-[2%]">
                        Airtime to Cash
                      </p>
                    </div>
                    {/* <img src={down} alt="" /> */}
                  </div>
                </div>
              )}
            </Link>

            <div className=" hover:bg-slate-300 rounded-xl ">
              <div className="flex items-center px-[10px]  pt-[9px] justify-center">
                <div className="flex w-[197px] justify-between">
                  <div className="flex gap-[14px]">
                    <img src={phone} alt="" />
                    <p className="font-medium  text-[16px] leading-7 tracking-[2%]">
                      Buy Airtime
                    </p>
                  </div>
                </div>
              </div>
              <div className="w-full flex justify-end pb-1">
                <Status status="pending" text="comming soon" />
              </div>
            </div>

            <div className=" hover:bg-slate-300 rounded-xl ">
              <div className="flex items-center px-[10px]  pt-[9px] justify-center">
                <div className="flex w-[197px] justify-between">
                  <div className="flex gap-[14px]">
                    <img src={wifi} alt="" />
                    <p className="font-medium  text-[16px] leading-7 tracking-[2%]">
                      Buy Data
                    </p>
                  </div>
                </div>
              </div>
              <div className="w-full flex justify-end pb-1">
                <Status status="pending" text="comming soon" />
              </div>
            </div>

            <div className=" hover:bg-slate-300 rounded-xl ">
              <div className="flex items-center px-[10px]  pt-[9px] justify-center">
                <div className="flex w-[197px] justify-between">
                  <div className="flex gap-[14px]">
                    <img src={tv} alt="" />
                    <p className="font-medium  text-[16px] leading-7 tracking-[2%]">
                      Tv Subscription
                    </p>
                  </div>
                </div>
              </div>
              <div className="w-full flex justify-end pb-1">
                <Status status="pending" text="comming soon" />
              </div>
            </div>

            <div className=" hover:bg-slate-300 rounded-xl ">
              <div className="flex items-center px-[10px]  pt-[9px] justify-center">
                <div className="flex w-[197px] justify-between">
                  <div className="flex gap-[14px]">
                    <img src={lighting} alt="" />
                    <p className="font-medium  text-[16px] leading-7 tracking-[2%]">
                      Pay Electric Bill
                    </p>
                  </div>
                </div>
              </div>
              <div className="w-full flex justify-end pb-1">
                <Status status="pending" text="comming soon" />
              </div>
            </div>

            <Link to="/help&support">
              {page === "support" ? (
                <div className="flex items-center px-[10px]  py-[9px] justify-center bg-[#4169E1] rounded-xl">
                  <div className="flex w-[197px] justify-between">
                    <div className="flex gap-[14px]">
                      <img src={whiteheadset} alt="" />
                      <p className="font-medium text-[#ffffff] text-[16px] leading-7 tracking-[2%]">
                        Help & Support
                      </p>
                    </div>
                    {/* <img src={down} alt="" /> */}
                  </div>
                </div>
              ) : (
                <div className="flex items-center px-[10px]  py-[9px] justify-center hover:bg-slate-300  rounded-xl">
                  <div className="flex w-[197px] justify-between">
                    <div className="flex gap-[14px]">
                      <img src={headset} alt="" />
                      <p className="font-medium  text-[16px] leading-7 tracking-[2%]">
                        Help & Support
                      </p>
                    </div>
                    {/* <img src={down} alt="" /> */}
                  </div>
                </div>
              )}
            </Link>
          </div>
        </div>
        <Link to="/login">
          <div className="flex items-center   hover:bg-slate-300 rounded-xl  px-[10px] py-[9px] justify-center ">
            <div className="flex w-[197px] justify-between">
              <div className="flex gap-[14px]">
                <img src={logout} alt="" />
                <p className="font-medium text-[#4C689E] text-[16px] leading-7 tracking-[2%]">
                  Log Out
                </p>
              </div>
              <img src={down} alt="" />
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default sidebar;
